"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Shimmer = _interopRequireDefault(require("../Shimmer"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _shimmerContinueCard = _interopRequireDefault(require("./shimmerContinueCard.proptypes"));

var ShimmerContinueCardContainer = _styledComponents.default.div.withConfig({
  displayName: "ShimmerContinueCard__ShimmerContinueCardContainer",
  componentId: "sc-1y7y9qf-0"
})(["", ";height:", ";grid-column:", ";-ms-grid-column-span:", ";outline:none !important;border-radius:", ";scroll-snap-align:start;&:focus-within{border:", ";}box-sizing:border-box;"], function (_ref) {
  var columnSpan = _ref.columnSpan;
  return columnSpan && "display: grid";
}, function (_ref2) {
  var columnSpan = _ref2.columnSpan;
  return columnSpan ? "100%" : "fit-content";
}, function (_ref3) {
  var columnSpan = _ref3.columnSpan;
  return "span ".concat(columnSpan, ";");
}, function (_ref4) {
  var columnSpan = _ref4.columnSpan;
  return columnSpan;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.borderRadius.normal;
}, function (_ref6) {
  var theme = _ref6.theme,
      focusEffect = _ref6.focusEffect;
  return focusEffect && "1px solid  ".concat(theme.colors.secondaryDark);
});

var ShimmerContinueCardCard = _styledComponents.default.div.withConfig({
  displayName: "ShimmerContinueCard__ShimmerContinueCardCard",
  componentId: "sc-1y7y9qf-1"
})(["background-color:", ";margin:", ";padding:", ";border:1px solid ", ";border-radius:", ";box-shadow:0px 1px 2px rgba(0,0,0,0.08);.shimmer-continue-search:not(:last-child){margin-bottom:", ";}"], function (props) {
  return props.theme.colors.default;
}, function (props) {
  return props.theme.space.micro;
}, function (props) {
  return props.theme.space.small;
}, function (props) {
  return props.theme.colors.greyLight;
}, function (props) {
  return props.borderRadius;
}, function (props) {
  return props.theme.space.tiny;
});

var ShimmerContinueCard = function ShimmerContinueCard(props) {
  var columnSpan = props.columnSpan,
      borderRadius = props.borderRadius,
      theme = props.theme,
      accessible = props.accessible,
      customProperties = props.customProperties;
  var shimmerCustomProps = {
    className: 'shimmer-continue-search'
  };
  var shimmerOtherProps = {
    accessible: false,
    customProperties: shimmerCustomProps
  };
  var tabIndex = !accessible ? '-1' : '0';
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(ShimmerContinueCardContainer, (0, _extends2.default)({
    tabIndex: tabIndex,
    columnSpan: columnSpan
  }, customProperties), /*#__PURE__*/_react.default.createElement(ShimmerContinueCardCard, {
    borderRadius: borderRadius
  }, /*#__PURE__*/_react.default.createElement(_Shimmer.default, (0, _extends2.default)({
    width: "95%"
  }, shimmerOtherProps)), /*#__PURE__*/_react.default.createElement(_Shimmer.default, (0, _extends2.default)({
    width: "48%"
  }, shimmerOtherProps)), /*#__PURE__*/_react.default.createElement(_Shimmer.default, (0, _extends2.default)({
    width: "30%"
  }, shimmerOtherProps)))));
};

ShimmerContinueCard.propTypes = _shimmerContinueCard.default.PropTypes;
ShimmerContinueCard.defaultProps = _shimmerContinueCard.default.DefaultProps;
var _default = ShimmerContinueCard;
exports.default = _default;